// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/usage.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { SupportedModel } from "./agent_pb";
import { file_gitpod_v1_agent } from "./agent_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { RunnerKind } from "./runner_configuration_pb";
import { file_gitpod_v1_runner_configuration } from "./runner_configuration_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/usage.proto.
 */
export const file_gitpod_v1_usage: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_agent, file_gitpod_v1_pagination, file_gitpod_v1_runner_configuration, file_google_protobuf_timestamp]);

/**
 * DateRange specifies a time period for queries.
 *
 * @generated from message gitpod.v1.DateRange
 */
export type DateRange = Message<"gitpod.v1.DateRange"> & {
  /**
   * Start time of the date range (inclusive).
   *
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * End time of the date range (exclusive).
   *
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;
};

/**
 * Describes the message gitpod.v1.DateRange.
 * Use `create(DateRangeSchema)` to create a new message.
 */
export const DateRangeSchema: GenMessage<DateRange> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 0);

/**
 * @generated from message gitpod.v1.TimeSeriesPoint
 */
export type TimeSeriesPoint = Message<"gitpod.v1.TimeSeriesPoint"> & {
  /**
   * Timestamp for this data point.
   *
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * The numerical value for this data point.
   *
   * @generated from field: int32 value = 2;
   */
  value: number;
};

/**
 * Describes the message gitpod.v1.TimeSeriesPoint.
 * Use `create(TimeSeriesPointSchema)` to create a new message.
 */
export const TimeSeriesPointSchema: GenMessage<TimeSeriesPoint> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 1);

/**
 * EnvironmentUsageRecord represents a record of an environment from start to stop.
 *
 * @generated from message gitpod.v1.EnvironmentUsageRecord
 */
export type EnvironmentUsageRecord = Message<"gitpod.v1.EnvironmentUsageRecord"> & {
  /**
   * Environment usage record ID.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Environment ID associated with the record.
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * User ID is the ID of the user who created the environment associated with the record.
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * Project ID associated with the environment (if available).
   *
   * @generated from field: string project_id = 4;
   */
  projectId: string;

  /**
   * Runner ID associated with the environment.
   *
   * @generated from field: string runner_id = 5;
   */
  runnerId: string;

  /**
   * Environment class ID associated with the record.
   *
   * @generated from field: string environment_class_id = 6;
   */
  environmentClassId: string;

  /**
   * Time when the environment was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * Time when the environment was stopped.
   *
   * @generated from field: google.protobuf.Timestamp stopped_at = 8;
   */
  stoppedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.EnvironmentUsageRecord.
 * Use `create(EnvironmentUsageRecordSchema)` to create a new message.
 */
export const EnvironmentUsageRecordSchema: GenMessage<EnvironmentUsageRecord> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 2);

/**
 * @generated from message gitpod.v1.GetActiveUsersCountRequest
 */
export type GetActiveUsersCountRequest = Message<"gitpod.v1.GetActiveUsersCountRequest"> & {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message gitpod.v1.GetActiveUsersCountRequest.
 * Use `create(GetActiveUsersCountRequestSchema)` to create a new message.
 */
export const GetActiveUsersCountRequestSchema: GenMessage<GetActiveUsersCountRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 3);

/**
 * @generated from message gitpod.v1.GetActiveUsersCountResponse
 */
export type GetActiveUsersCountResponse = Message<"gitpod.v1.GetActiveUsersCountResponse"> & {
  /**
   * Count of active users in the date range.
   *
   * @generated from field: int64 count = 1;
   */
  count: bigint;

  /**
   * Fractional change in active users vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double trend = 2;
   */
  trend: number;
};

/**
 * Describes the message gitpod.v1.GetActiveUsersCountResponse.
 * Use `create(GetActiveUsersCountResponseSchema)` to create a new message.
 */
export const GetActiveUsersCountResponseSchema: GenMessage<GetActiveUsersCountResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 4);

/**
 * @generated from message gitpod.v1.GetTopActiveUsersRequest
 */
export type GetTopActiveUsersRequest = Message<"gitpod.v1.GetTopActiveUsersRequest"> & {
  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 3;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.GetTopActiveUsersRequest.
 * Use `create(GetTopActiveUsersRequestSchema)` to create a new message.
 */
export const GetTopActiveUsersRequestSchema: GenMessage<GetTopActiveUsersRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 5);

/**
 * @generated from message gitpod.v1.GetTopActiveUsersResponse
 */
export type GetTopActiveUsersResponse = Message<"gitpod.v1.GetTopActiveUsersResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * List of users sorted by total runtime (descending).
   *
   * @generated from field: repeated gitpod.v1.GetTopActiveUsersResponse.UserRuntimeInfo users = 2;
   */
  users: GetTopActiveUsersResponse_UserRuntimeInfo[];
};

/**
 * Describes the message gitpod.v1.GetTopActiveUsersResponse.
 * Use `create(GetTopActiveUsersResponseSchema)` to create a new message.
 */
export const GetTopActiveUsersResponseSchema: GenMessage<GetTopActiveUsersResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 6);

/**
 * @generated from message gitpod.v1.GetTopActiveUsersResponse.UserRuntimeInfo
 */
export type GetTopActiveUsersResponse_UserRuntimeInfo = Message<"gitpod.v1.GetTopActiveUsersResponse.UserRuntimeInfo"> & {
  /**
   * User ID.
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * User name if available.
   *
   * @generated from field: string user_name = 2;
   */
  userName: string;

  /**
   * User avatar if available.
   *
   * @generated from field: string user_avatar_url = 3;
   */
  userAvatarUrl: string;

  /**
   * Total environment runtime in seconds.
   *
   * @generated from field: double total_runtime_seconds = 4;
   */
  totalRuntimeSeconds: number;
};

/**
 * Describes the message gitpod.v1.GetTopActiveUsersResponse.UserRuntimeInfo.
 * Use `create(GetTopActiveUsersResponse_UserRuntimeInfoSchema)` to create a new message.
 */
export const GetTopActiveUsersResponse_UserRuntimeInfoSchema: GenMessage<GetTopActiveUsersResponse_UserRuntimeInfo> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 6, 0);

/**
 * @generated from message gitpod.v1.GetActiveUsersTimeSeriesRequest
 */
export type GetActiveUsersTimeSeriesRequest = Message<"gitpod.v1.GetActiveUsersTimeSeriesRequest"> & {
  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution: Resolution;
};

/**
 * Describes the message gitpod.v1.GetActiveUsersTimeSeriesRequest.
 * Use `create(GetActiveUsersTimeSeriesRequestSchema)` to create a new message.
 */
export const GetActiveUsersTimeSeriesRequestSchema: GenMessage<GetActiveUsersTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 7);

/**
 * @generated from message gitpod.v1.GetActiveUsersTimeSeriesResponse
 */
export type GetActiveUsersTimeSeriesResponse = Message<"gitpod.v1.GetActiveUsersTimeSeriesResponse"> & {
  /**
   * Weekly active users time series [WAU]
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint weekly_active_users = 1;
   */
  weeklyActiveUsers: TimeSeriesPoint[];

  /**
   * Weekly active returning users time series [WAU2+]
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint weekly_active_returning_users = 2;
   */
  weeklyActiveReturningUsers: TimeSeriesPoint[];
};

/**
 * Describes the message gitpod.v1.GetActiveUsersTimeSeriesResponse.
 * Use `create(GetActiveUsersTimeSeriesResponseSchema)` to create a new message.
 */
export const GetActiveUsersTimeSeriesResponseSchema: GenMessage<GetActiveUsersTimeSeriesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 8);

/**
 * @generated from message gitpod.v1.ListEnvironmentUsageRecordsRequest
 */
export type ListEnvironmentUsageRecordsRequest = Message<"gitpod.v1.ListEnvironmentUsageRecordsRequest"> & {
  /**
   * Pagination options.
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * Filter options.
   *
   * @generated from field: gitpod.v1.ListEnvironmentUsageRecordsRequest.Filter filter = 2;
   */
  filter?: ListEnvironmentUsageRecordsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListEnvironmentUsageRecordsRequest.
 * Use `create(ListEnvironmentUsageRecordsRequestSchema)` to create a new message.
 */
export const ListEnvironmentUsageRecordsRequestSchema: GenMessage<ListEnvironmentUsageRecordsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 9);

/**
 * @generated from message gitpod.v1.ListEnvironmentUsageRecordsRequest.Filter
 */
export type ListEnvironmentUsageRecordsRequest_Filter = Message<"gitpod.v1.ListEnvironmentUsageRecordsRequest.Filter"> & {
  /**
   * Optional project ID to filter runtime records by.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * Date range to query runtime records within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;
};

/**
 * Describes the message gitpod.v1.ListEnvironmentUsageRecordsRequest.Filter.
 * Use `create(ListEnvironmentUsageRecordsRequest_FilterSchema)` to create a new message.
 */
export const ListEnvironmentUsageRecordsRequest_FilterSchema: GenMessage<ListEnvironmentUsageRecordsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 9, 0);

/**
 * @generated from message gitpod.v1.ListEnvironmentUsageRecordsResponse
 */
export type ListEnvironmentUsageRecordsResponse = Message<"gitpod.v1.ListEnvironmentUsageRecordsResponse"> & {
  /**
   * Pagination response.
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * List of environment runtime records.
   *
   * @generated from field: repeated gitpod.v1.EnvironmentUsageRecord records = 2;
   */
  records: EnvironmentUsageRecord[];
};

/**
 * Describes the message gitpod.v1.ListEnvironmentUsageRecordsResponse.
 * Use `create(ListEnvironmentUsageRecordsResponseSchema)` to create a new message.
 */
export const ListEnvironmentUsageRecordsResponseSchema: GenMessage<ListEnvironmentUsageRecordsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 10);

/**
 * @generated from message gitpod.v1.GetActiveEnvironmentsCountRequest
 */
export type GetActiveEnvironmentsCountRequest = Message<"gitpod.v1.GetActiveEnvironmentsCountRequest"> & {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message gitpod.v1.GetActiveEnvironmentsCountRequest.
 * Use `create(GetActiveEnvironmentsCountRequestSchema)` to create a new message.
 */
export const GetActiveEnvironmentsCountRequestSchema: GenMessage<GetActiveEnvironmentsCountRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 11);

/**
 * @generated from message gitpod.v1.GetActiveEnvironmentsCountResponse
 */
export type GetActiveEnvironmentsCountResponse = Message<"gitpod.v1.GetActiveEnvironmentsCountResponse"> & {
  /**
   * Count of active environments in the date range.
   *
   * @generated from field: int64 count = 1;
   */
  count: bigint;

  /**
   * Fractional change in active environments vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double trend = 2;
   */
  trend: number;
};

/**
 * Describes the message gitpod.v1.GetActiveEnvironmentsCountResponse.
 * Use `create(GetActiveEnvironmentsCountResponseSchema)` to create a new message.
 */
export const GetActiveEnvironmentsCountResponseSchema: GenMessage<GetActiveEnvironmentsCountResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 12);

/**
 * @generated from message gitpod.v1.GetActiveEnvironmentsTimeSeriesRequest
 */
export type GetActiveEnvironmentsTimeSeriesRequest = Message<"gitpod.v1.GetActiveEnvironmentsTimeSeriesRequest"> & {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution: Resolution;
};

/**
 * Describes the message gitpod.v1.GetActiveEnvironmentsTimeSeriesRequest.
 * Use `create(GetActiveEnvironmentsTimeSeriesRequestSchema)` to create a new message.
 */
export const GetActiveEnvironmentsTimeSeriesRequestSchema: GenMessage<GetActiveEnvironmentsTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 13);

/**
 * @generated from message gitpod.v1.GetActiveEnvironmentsTimeSeriesResponse
 */
export type GetActiveEnvironmentsTimeSeriesResponse = Message<"gitpod.v1.GetActiveEnvironmentsTimeSeriesResponse"> & {
  /**
   * Active environments time series
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint active_environments = 1;
   */
  activeEnvironments: TimeSeriesPoint[];
};

/**
 * Describes the message gitpod.v1.GetActiveEnvironmentsTimeSeriesResponse.
 * Use `create(GetActiveEnvironmentsTimeSeriesResponseSchema)` to create a new message.
 */
export const GetActiveEnvironmentsTimeSeriesResponseSchema: GenMessage<GetActiveEnvironmentsTimeSeriesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 14);

/**
 * @generated from message gitpod.v1.GetEnvironmentRuntimeRequest
 */
export type GetEnvironmentRuntimeRequest = Message<"gitpod.v1.GetEnvironmentRuntimeRequest"> & {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;
};

/**
 * Describes the message gitpod.v1.GetEnvironmentRuntimeRequest.
 * Use `create(GetEnvironmentRuntimeRequestSchema)` to create a new message.
 */
export const GetEnvironmentRuntimeRequestSchema: GenMessage<GetEnvironmentRuntimeRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 15);

/**
 * @generated from message gitpod.v1.GetEnvironmentRuntimeResponse
 */
export type GetEnvironmentRuntimeResponse = Message<"gitpod.v1.GetEnvironmentRuntimeResponse"> & {
  /**
   * Total runtime in seconds.
   *
   * @generated from field: int64 total_runtime_seconds = 1;
   */
  totalRuntimeSeconds: bigint;

  /**
   * Fractional change in total runtime vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double trend = 2;
   */
  trend: number;
};

/**
 * Describes the message gitpod.v1.GetEnvironmentRuntimeResponse.
 * Use `create(GetEnvironmentRuntimeResponseSchema)` to create a new message.
 */
export const GetEnvironmentRuntimeResponseSchema: GenMessage<GetEnvironmentRuntimeResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 16);

/**
 * @generated from message gitpod.v1.GetEnvironmentRuntimeTimeSeriesRequest
 */
export type GetEnvironmentRuntimeTimeSeriesRequest = Message<"gitpod.v1.GetEnvironmentRuntimeTimeSeriesRequest"> & {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution: Resolution;
};

/**
 * Describes the message gitpod.v1.GetEnvironmentRuntimeTimeSeriesRequest.
 * Use `create(GetEnvironmentRuntimeTimeSeriesRequestSchema)` to create a new message.
 */
export const GetEnvironmentRuntimeTimeSeriesRequestSchema: GenMessage<GetEnvironmentRuntimeTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 17);

/**
 * @generated from message gitpod.v1.GetEnvironmentRuntimeTimeSeriesResponse
 */
export type GetEnvironmentRuntimeTimeSeriesResponse = Message<"gitpod.v1.GetEnvironmentRuntimeTimeSeriesResponse"> & {
  /**
   * Total runtime time series
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint total_runtime = 1;
   */
  totalRuntime: TimeSeriesPoint[];
};

/**
 * Describes the message gitpod.v1.GetEnvironmentRuntimeTimeSeriesResponse.
 * Use `create(GetEnvironmentRuntimeTimeSeriesResponseSchema)` to create a new message.
 */
export const GetEnvironmentRuntimeTimeSeriesResponseSchema: GenMessage<GetEnvironmentRuntimeTimeSeriesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 18);

/**
 * @generated from message gitpod.v1.GetTopProjectsRequest
 */
export type GetTopProjectsRequest = Message<"gitpod.v1.GetTopProjectsRequest"> & {
  /**
   * Pagination options.
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;
};

/**
 * Describes the message gitpod.v1.GetTopProjectsRequest.
 * Use `create(GetTopProjectsRequestSchema)` to create a new message.
 */
export const GetTopProjectsRequestSchema: GenMessage<GetTopProjectsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 19);

/**
 * @generated from message gitpod.v1.GetTopProjectsResponse
 */
export type GetTopProjectsResponse = Message<"gitpod.v1.GetTopProjectsResponse"> & {
  /**
   * List of projects sorted by total runtime (descending).
   *
   * @generated from field: repeated gitpod.v1.GetTopProjectsResponse.ProjectRuntimeInfo projects = 1;
   */
  projects: GetTopProjectsResponse_ProjectRuntimeInfo[];

  /**
   * Pagination response.
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;
};

/**
 * Describes the message gitpod.v1.GetTopProjectsResponse.
 * Use `create(GetTopProjectsResponseSchema)` to create a new message.
 */
export const GetTopProjectsResponseSchema: GenMessage<GetTopProjectsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 20);

/**
 * @generated from message gitpod.v1.GetTopProjectsResponse.ProjectRuntimeInfo
 */
export type GetTopProjectsResponse_ProjectRuntimeInfo = Message<"gitpod.v1.GetTopProjectsResponse.ProjectRuntimeInfo"> & {
  /**
   * Project ID.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * Project name if available.
   *
   * @generated from field: string project_name = 2;
   */
  projectName: string;

  /**
   * Total runtime in seconds.
   *
   * @generated from field: int64 total_runtime_seconds = 3;
   */
  totalRuntimeSeconds: bigint;
};

/**
 * Describes the message gitpod.v1.GetTopProjectsResponse.ProjectRuntimeInfo.
 * Use `create(GetTopProjectsResponse_ProjectRuntimeInfoSchema)` to create a new message.
 */
export const GetTopProjectsResponse_ProjectRuntimeInfoSchema: GenMessage<GetTopProjectsResponse_ProjectRuntimeInfo> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 20, 0);

/**
 * @generated from message gitpod.v1.GetTopEnvironmentClassesRequest
 */
export type GetTopEnvironmentClassesRequest = Message<"gitpod.v1.GetTopEnvironmentClassesRequest"> & {
  /**
   * Pagination options.
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 3;
   */
  projectId: string;
};

/**
 * Describes the message gitpod.v1.GetTopEnvironmentClassesRequest.
 * Use `create(GetTopEnvironmentClassesRequestSchema)` to create a new message.
 */
export const GetTopEnvironmentClassesRequestSchema: GenMessage<GetTopEnvironmentClassesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 21);

/**
 * @generated from message gitpod.v1.GetTopEnvironmentClassesResponse
 */
export type GetTopEnvironmentClassesResponse = Message<"gitpod.v1.GetTopEnvironmentClassesResponse"> & {
  /**
   * List of environment classes sorted by total runtime (descending). All environment classes belonging to local runners are grouped together.
   *
   * @generated from field: repeated gitpod.v1.GetTopEnvironmentClassesResponse.EnvironmentClassRuntimeInfo environment_classes = 1;
   */
  environmentClasses: GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo[];

  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;
};

/**
 * Describes the message gitpod.v1.GetTopEnvironmentClassesResponse.
 * Use `create(GetTopEnvironmentClassesResponseSchema)` to create a new message.
 */
export const GetTopEnvironmentClassesResponseSchema: GenMessage<GetTopEnvironmentClassesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 22);

/**
 * @generated from message gitpod.v1.GetTopEnvironmentClassesResponse.EnvironmentClassRuntimeInfo
 */
export type GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo = Message<"gitpod.v1.GetTopEnvironmentClassesResponse.EnvironmentClassRuntimeInfo"> & {
  /**
   * Environment class ID. Not set for local runners.
   *
   * @generated from field: string environment_class_id = 1;
   */
  environmentClassId: string;

  /**
   * Type of runner that created the environment class.
   *
   * @generated from field: gitpod.v1.RunnerKind runner_kind = 2;
   */
  runnerKind: RunnerKind;

  /**
   * Name of the runner that created the environment class.
   *
   * @generated from field: string runner_name = 3;
   */
  runnerName: string;

  /**
   * Environment class name if available.
   *
   * @generated from field: string environment_class_name = 4;
   */
  environmentClassName: string;

  /**
   * Total runtime in seconds.
   *
   * @generated from field: int64 total_runtime_seconds = 5;
   */
  totalRuntimeSeconds: bigint;
};

/**
 * Describes the message gitpod.v1.GetTopEnvironmentClassesResponse.EnvironmentClassRuntimeInfo.
 * Use `create(GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfoSchema)` to create a new message.
 */
export const GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfoSchema: GenMessage<GetTopEnvironmentClassesResponse_EnvironmentClassRuntimeInfo> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 22, 0);

/**
 * @generated from message gitpod.v1.GetAdoptionUsageSummaryRequest
 */
export type GetAdoptionUsageSummaryRequest = Message<"gitpod.v1.GetAdoptionUsageSummaryRequest"> & {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Optional user ID to filter metrics for a specific user (personal insights view).
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message gitpod.v1.GetAdoptionUsageSummaryRequest.
 * Use `create(GetAdoptionUsageSummaryRequestSchema)` to create a new message.
 */
export const GetAdoptionUsageSummaryRequestSchema: GenMessage<GetAdoptionUsageSummaryRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 23);

/**
 * @generated from message gitpod.v1.GetAdoptionUsageSummaryResponse
 */
export type GetAdoptionUsageSummaryResponse = Message<"gitpod.v1.GetAdoptionUsageSummaryResponse"> & {
  /**
   * Average environment runtime in seconds per active user.
   *
   * @generated from field: double env_runtime_per_user_seconds = 1;
   */
  envRuntimePerUserSeconds: number;

  /**
   * Fractional change in env_runtime_per_user_seconds vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double env_runtime_per_user_trend = 2;
   */
  envRuntimePerUserTrend: number;

  /**
   * Count of active users in the date range.
   *
   * @generated from field: int64 active_users_count = 3;
   */
  activeUsersCount: bigint;

  /**
   * Fractional change in active_users_count vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double active_users_trend = 4;
   */
  activeUsersTrend: number;

  /**
   * Count of power users in the date range.
   *
   * @generated from field: int64 power_users_count = 5;
   */
  powerUsersCount: bigint;

  /**
   * Fractional change in power_users_count vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double power_users_trend = 6;
   */
  powerUsersTrend: number;

  /**
   * Threshold in seconds used to determine power users.
   * Displayed to users so they understand the definition.
   *
   * @generated from field: int64 power_users_threshold_seconds = 7;
   */
  powerUsersThresholdSeconds: bigint;

  /**
   * Count of environment sessions (total starts) in the date range.
   *
   * @generated from field: int64 sessions_count = 8;
   */
  sessionsCount: bigint;

  /**
   * Fractional change in sessions_count vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double sessions_trend = 9;
   */
  sessionsTrend: number;

  /**
   * Sparkline data for the card's trend line (typically ~4 weekly points).
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint sparkline = 10;
   */
  sparkline: TimeSeriesPoint[];
};

/**
 * Describes the message gitpod.v1.GetAdoptionUsageSummaryResponse.
 * Use `create(GetAdoptionUsageSummaryResponseSchema)` to create a new message.
 */
export const GetAdoptionUsageSummaryResponseSchema: GenMessage<GetAdoptionUsageSummaryResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 24);

/**
 * @generated from message gitpod.v1.GetEnvironmentSessionsTimeSeriesRequest
 */
export type GetEnvironmentSessionsTimeSeriesRequest = Message<"gitpod.v1.GetEnvironmentSessionsTimeSeriesRequest"> & {
  /**
   * Date range to query metrics within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to filter metrics by.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution: Resolution;
};

/**
 * Describes the message gitpod.v1.GetEnvironmentSessionsTimeSeriesRequest.
 * Use `create(GetEnvironmentSessionsTimeSeriesRequestSchema)` to create a new message.
 */
export const GetEnvironmentSessionsTimeSeriesRequestSchema: GenMessage<GetEnvironmentSessionsTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 25);

/**
 * @generated from message gitpod.v1.GetEnvironmentSessionsTimeSeriesResponse
 */
export type GetEnvironmentSessionsTimeSeriesResponse = Message<"gitpod.v1.GetEnvironmentSessionsTimeSeriesResponse"> & {
  /**
   * Environment sessions time series. Counts total environment starts per time bucket,
   * as opposed to GetActiveEnvironmentsTimeSeries which counts distinct environment IDs.
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint sessions = 1;
   */
  sessions: TimeSeriesPoint[];
};

/**
 * Describes the message gitpod.v1.GetEnvironmentSessionsTimeSeriesResponse.
 * Use `create(GetEnvironmentSessionsTimeSeriesResponseSchema)` to create a new message.
 */
export const GetEnvironmentSessionsTimeSeriesResponseSchema: GenMessage<GetEnvironmentSessionsTimeSeriesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 26);

/**
 * ToolBreakdown contains stats for a single AI tool (or human).
 *
 * @generated from message gitpod.v1.ToolBreakdown
 */
export type ToolBreakdown = Message<"gitpod.v1.ToolBreakdown"> & {
  /**
   * The tool these stats are for.
   *
   * @generated from field: gitpod.v1.CoAuthorTool tool = 1;
   */
  tool: CoAuthorTool;

  /**
   * Number of commits attributed to this tool.
   *
   * @generated from field: int64 commits = 2;
   */
  commits: bigint;

  /**
   * Lines added by this tool.
   *
   * @generated from field: int64 lines_added = 3;
   */
  linesAdded: bigint;

  /**
   * Lines removed by this tool.
   *
   * @generated from field: int64 lines_removed = 4;
   */
  linesRemoved: bigint;

  /**
   * Distinct authors who used this tool.
   *
   * @generated from field: int64 distinct_authors = 5;
   */
  distinctAuthors: bigint;
};

/**
 * Describes the message gitpod.v1.ToolBreakdown.
 * Use `create(ToolBreakdownSchema)` to create a new message.
 */
export const ToolBreakdownSchema: GenMessage<ToolBreakdown> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 27);

/**
 * CoAuthorSummary contains aggregate totals for a date range.
 *
 * @generated from message gitpod.v1.CoAuthorSummary
 */
export type CoAuthorSummary = Message<"gitpod.v1.CoAuthorSummary"> & {
  /**
   * Total number of commits in the date range.
   *
   * @generated from field: int64 total_commits = 1;
   */
  totalCommits: bigint;

  /**
   * Total lines added across all commits.
   *
   * @generated from field: int64 total_lines_added = 2;
   */
  totalLinesAdded: bigint;

  /**
   * Total lines removed across all commits.
   *
   * @generated from field: int64 total_lines_removed = 3;
   */
  totalLinesRemoved: bigint;

  /**
   * Number of distinct authors (by author_hash).
   *
   * @generated from field: int64 distinct_authors = 4;
   */
  distinctAuthors: bigint;

  /**
   * Per-tool breakdown of contribution stats.
   *
   * @generated from field: repeated gitpod.v1.ToolBreakdown by_tool = 5;
   */
  byTool: ToolBreakdown[];

  /**
   * Fractional change in total_commits compared to the previous period of equal
   * length. Computed as (current - previous) / previous. Zero when there is no
   * previous data.
   *
   * @generated from field: double total_commits_trend = 6;
   */
  totalCommitsTrend: number;

  /**
   * Fractional change in total_lines_added compared to the previous period.
   *
   * @generated from field: double total_lines_added_trend = 7;
   */
  totalLinesAddedTrend: number;

  /**
   * Fractional change in total_lines_removed compared to the previous period.
   *
   * @generated from field: double total_lines_removed_trend = 8;
   */
  totalLinesRemovedTrend: number;

  /**
   * Fractional change in distinct_authors compared to the previous period.
   *
   * @generated from field: double distinct_authors_trend = 9;
   */
  distinctAuthorsTrend: number;
};

/**
 * Describes the message gitpod.v1.CoAuthorSummary.
 * Use `create(CoAuthorSummarySchema)` to create a new message.
 */
export const CoAuthorSummarySchema: GenMessage<CoAuthorSummary> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 28);

/**
 * CoAuthorTimeBucket contains stats for a single time period.
 *
 * @generated from message gitpod.v1.CoAuthorTimeBucket
 */
export type CoAuthorTimeBucket = Message<"gitpod.v1.CoAuthorTimeBucket"> & {
  /**
   * Start of this time bucket.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * Per-tool breakdown for this bucket.
   *
   * @generated from field: repeated gitpod.v1.ToolBreakdown by_tool = 2;
   */
  byTool: ToolBreakdown[];

  /**
   * Total lines added in this bucket (across all tools).
   *
   * @generated from field: int64 total_lines_added = 3;
   */
  totalLinesAdded: bigint;

  /**
   * Total lines removed in this bucket (across all tools).
   *
   * @generated from field: int64 total_lines_removed = 4;
   */
  totalLinesRemoved: bigint;

  /**
   * Ratio of AI-assisted lines added to total lines added (0.0–1.0).
   *
   * @generated from field: double ai_ratio = 5;
   */
  aiRatio: number;

  /**
   * Total number of commits in this bucket (across all tools).
   *
   * @generated from field: int64 total_commits = 6;
   */
  totalCommits: bigint;

  /**
   * Number of distinct authors (by author_hash) in this bucket.
   *
   * @generated from field: int64 distinct_authors = 7;
   */
  distinctAuthors: bigint;
};

/**
 * Describes the message gitpod.v1.CoAuthorTimeBucket.
 * Use `create(CoAuthorTimeBucketSchema)` to create a new message.
 */
export const CoAuthorTimeBucketSchema: GenMessage<CoAuthorTimeBucket> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 29);

/**
 * AgentTraceSummary contains aggregate totals for a date range.
 *
 * @generated from message gitpod.v1.AgentTraceSummary
 */
export type AgentTraceSummary = Message<"gitpod.v1.AgentTraceSummary"> & {
  /**
   * Total number of agent trace sessions in the date range.
   *
   * @generated from field: int64 total_sessions = 1;
   */
  totalSessions: bigint;

  /**
   * Total lines added across all sessions.
   *
   * @generated from field: int64 total_lines_added = 2;
   */
  totalLinesAdded: bigint;

  /**
   * Total lines removed across all sessions.
   *
   * @generated from field: int64 total_lines_removed = 3;
   */
  totalLinesRemoved: bigint;

  /**
   * Per-model breakdown of session stats.
   *
   * @generated from field: repeated gitpod.v1.AgentTraceModelBreakdown by_model = 4;
   */
  byModel: AgentTraceModelBreakdown[];

  /**
   * Fractional change in total_sessions compared to the previous period of
   * equal length. Computed as (current - previous) / previous. Zero when there
   * is no previous data.
   *
   * @generated from field: double total_sessions_trend = 5;
   */
  totalSessionsTrend: number;

  /**
   * Fractional change in total_lines_added compared to the previous period.
   *
   * @generated from field: double total_lines_added_trend = 6;
   */
  totalLinesAddedTrend: number;

  /**
   * Fractional change in total_lines_removed compared to the previous period.
   *
   * @generated from field: double total_lines_removed_trend = 7;
   */
  totalLinesRemovedTrend: number;
};

/**
 * Describes the message gitpod.v1.AgentTraceSummary.
 * Use `create(AgentTraceSummarySchema)` to create a new message.
 */
export const AgentTraceSummarySchema: GenMessage<AgentTraceSummary> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 30);

/**
 * AgentTraceModelBreakdown contains stats for a single LLM model.
 *
 * @generated from message gitpod.v1.AgentTraceModelBreakdown
 */
export type AgentTraceModelBreakdown = Message<"gitpod.v1.AgentTraceModelBreakdown"> & {
  /**
   * The model these stats are for.
   *
   * @generated from field: gitpod.v1.SupportedModel model = 1;
   */
  model: SupportedModel;

  /**
   * Number of sessions that used this model.
   *
   * @generated from field: int64 sessions = 2;
   */
  sessions: bigint;

  /**
   * Lines added by sessions using this model.
   *
   * @generated from field: int64 lines_added = 3;
   */
  linesAdded: bigint;

  /**
   * Lines removed by sessions using this model.
   *
   * @generated from field: int64 lines_removed = 4;
   */
  linesRemoved: bigint;
};

/**
 * Describes the message gitpod.v1.AgentTraceModelBreakdown.
 * Use `create(AgentTraceModelBreakdownSchema)` to create a new message.
 */
export const AgentTraceModelBreakdownSchema: GenMessage<AgentTraceModelBreakdown> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 31);

/**
 * AgentTraceTimeBucket contains stats for a single time period.
 *
 * @generated from message gitpod.v1.AgentTraceTimeBucket
 */
export type AgentTraceTimeBucket = Message<"gitpod.v1.AgentTraceTimeBucket"> & {
  /**
   * Start of this time bucket.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * Number of agent trace sessions in this bucket.
   *
   * @generated from field: int64 total_sessions = 2;
   */
  totalSessions: bigint;

  /**
   * Total lines added in this bucket.
   *
   * @generated from field: int64 total_lines_added = 3;
   */
  totalLinesAdded: bigint;

  /**
   * Total lines removed in this bucket.
   *
   * @generated from field: int64 total_lines_removed = 4;
   */
  totalLinesRemoved: bigint;

  /**
   * Per-model breakdown for this bucket.
   *
   * @generated from field: repeated gitpod.v1.AgentTraceModelBreakdown by_model = 5;
   */
  byModel: AgentTraceModelBreakdown[];
};

/**
 * Describes the message gitpod.v1.AgentTraceTimeBucket.
 * Use `create(AgentTraceTimeBucketSchema)` to create a new message.
 */
export const AgentTraceTimeBucketSchema: GenMessage<AgentTraceTimeBucket> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 32);

/**
 * PrSummary contains aggregate PR speed metrics for a date range.
 *
 * @generated from message gitpod.v1.PrSummary
 */
export type PrSummary = Message<"gitpod.v1.PrSummary"> & {
  /**
   * Median lead time for changes in seconds (first commit → merge).
   *
   * @generated from field: double lead_time_seconds = 1;
   */
  leadTimeSeconds: number;

  /**
   * Fractional change in lead_time_seconds vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double lead_time_trend = 2;
   */
  leadTimeTrend: number;

  /**
   * Total PRs merged in the date range.
   *
   * @generated from field: int64 prs_merged_count = 3;
   */
  prsMergedCount: bigint;

  /**
   * Fractional change in prs_merged_count vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double prs_merged_trend = 4;
   */
  prsMergedTrend: number;

  /**
   * Median time to first approval in seconds.
   * Zero when no PRs in the range had approvals.
   *
   * @generated from field: double time_to_first_approval_seconds = 5;
   */
  timeToFirstApprovalSeconds: number;

  /**
   * Fractional change in time_to_first_approval_seconds vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double time_to_first_approval_trend = 6;
   */
  timeToFirstApprovalTrend: number;

  /**
   * PRs merged to the default branch per week.
   *
   * @generated from field: double deployment_frequency = 7;
   */
  deploymentFrequency: number;

  /**
   * Fractional change in deployment_frequency vs previous period.
   * Computed as (current - previous) / previous.
   *
   * @generated from field: double deployment_frequency_trend = 8;
   */
  deploymentFrequencyTrend: number;
};

/**
 * Describes the message gitpod.v1.PrSummary.
 * Use `create(PrSummarySchema)` to create a new message.
 */
export const PrSummarySchema: GenMessage<PrSummary> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 33);

/**
 * PrTimeBucket contains PR speed metrics for a single time period.
 *
 * @generated from message gitpod.v1.PrTimeBucket
 */
export type PrTimeBucket = Message<"gitpod.v1.PrTimeBucket"> & {
  /**
   * Start of this time bucket.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * Median lead time in seconds for PRs merged in this bucket.
   *
   * @generated from field: double lead_time_seconds = 2;
   */
  leadTimeSeconds: number;

  /**
   * Number of PRs merged in this bucket.
   *
   * @generated from field: int64 prs_merged_count = 3;
   */
  prsMergedCount: bigint;

  /**
   * Median time to first approval in seconds for PRs in this bucket.
   * Zero when no PRs in the bucket had approvals.
   *
   * @generated from field: double time_to_first_approval_seconds = 4;
   */
  timeToFirstApprovalSeconds: number;

  /**
   * Total number of deploys (merged PRs) in this bucket.
   *
   * @generated from field: int64 deploys = 5;
   */
  deploys: bigint;
};

/**
 * Describes the message gitpod.v1.PrTimeBucket.
 * Use `create(PrTimeBucketSchema)` to create a new message.
 */
export const PrTimeBucketSchema: GenMessage<PrTimeBucket> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 34);

/**
 * @generated from message gitpod.v1.GetCoAuthorSummaryRequest
 */
export type GetCoAuthorSummaryRequest = Message<"gitpod.v1.GetCoAuthorSummaryRequest"> & {
  /**
   * Date range to query within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to scope results.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Optional user ID to scope results to a specific user.
   * Mutually exclusive with team_id.
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * Optional team ID to scope results to a specific team.
   * Mutually exclusive with user_id.
   *
   * @generated from field: string team_id = 4;
   */
  teamId: string;
};

/**
 * Describes the message gitpod.v1.GetCoAuthorSummaryRequest.
 * Use `create(GetCoAuthorSummaryRequestSchema)` to create a new message.
 */
export const GetCoAuthorSummaryRequestSchema: GenMessage<GetCoAuthorSummaryRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 35);

/**
 * @generated from message gitpod.v1.GetCoAuthorSummaryResponse
 */
export type GetCoAuthorSummaryResponse = Message<"gitpod.v1.GetCoAuthorSummaryResponse"> & {
  /**
   * Summary totals and trends for the requested date range.
   *
   * @generated from field: gitpod.v1.CoAuthorSummary summary = 1;
   */
  summary?: CoAuthorSummary;

  /**
   * Sparkline data for card rendering.
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint sparkline = 2;
   */
  sparkline: TimeSeriesPoint[];
};

/**
 * Describes the message gitpod.v1.GetCoAuthorSummaryResponse.
 * Use `create(GetCoAuthorSummaryResponseSchema)` to create a new message.
 */
export const GetCoAuthorSummaryResponseSchema: GenMessage<GetCoAuthorSummaryResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 36);

/**
 * @generated from message gitpod.v1.GetCoAuthorTimeSeriesRequest
 */
export type GetCoAuthorTimeSeriesRequest = Message<"gitpod.v1.GetCoAuthorTimeSeriesRequest"> & {
  /**
   * Date range to query within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to scope results.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution: Resolution;

  /**
   * Optional user ID to scope results to a specific user.
   * Mutually exclusive with team_id.
   *
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * Optional team ID to scope results to a specific team.
   * Mutually exclusive with user_id.
   *
   * @generated from field: string team_id = 5;
   */
  teamId: string;
};

/**
 * Describes the message gitpod.v1.GetCoAuthorTimeSeriesRequest.
 * Use `create(GetCoAuthorTimeSeriesRequestSchema)` to create a new message.
 */
export const GetCoAuthorTimeSeriesRequestSchema: GenMessage<GetCoAuthorTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 37);

/**
 * @generated from message gitpod.v1.GetCoAuthorTimeSeriesResponse
 */
export type GetCoAuthorTimeSeriesResponse = Message<"gitpod.v1.GetCoAuthorTimeSeriesResponse"> & {
  /**
   * Time series of contribution stats, bucketed by the requested resolution.
   *
   * @generated from field: repeated gitpod.v1.CoAuthorTimeBucket time_series = 1;
   */
  timeSeries: CoAuthorTimeBucket[];
};

/**
 * Describes the message gitpod.v1.GetCoAuthorTimeSeriesResponse.
 * Use `create(GetCoAuthorTimeSeriesResponseSchema)` to create a new message.
 */
export const GetCoAuthorTimeSeriesResponseSchema: GenMessage<GetCoAuthorTimeSeriesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 38);

/**
 * @generated from message gitpod.v1.GetAgentTraceSummaryRequest
 */
export type GetAgentTraceSummaryRequest = Message<"gitpod.v1.GetAgentTraceSummaryRequest"> & {
  /**
   * Date range to query within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to scope results.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Optional user ID to scope results to a specific user.
   * Mutually exclusive with team_id.
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * Optional team ID to scope results to a specific team.
   * Mutually exclusive with user_id.
   *
   * @generated from field: string team_id = 4;
   */
  teamId: string;
};

/**
 * Describes the message gitpod.v1.GetAgentTraceSummaryRequest.
 * Use `create(GetAgentTraceSummaryRequestSchema)` to create a new message.
 */
export const GetAgentTraceSummaryRequestSchema: GenMessage<GetAgentTraceSummaryRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 39);

/**
 * @generated from message gitpod.v1.GetAgentTraceSummaryResponse
 */
export type GetAgentTraceSummaryResponse = Message<"gitpod.v1.GetAgentTraceSummaryResponse"> & {
  /**
   * Summary totals and trends for the requested date range.
   *
   * @generated from field: gitpod.v1.AgentTraceSummary summary = 1;
   */
  summary?: AgentTraceSummary;

  /**
   * Sparkline data for card rendering.
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint sparkline = 2;
   */
  sparkline: TimeSeriesPoint[];
};

/**
 * Describes the message gitpod.v1.GetAgentTraceSummaryResponse.
 * Use `create(GetAgentTraceSummaryResponseSchema)` to create a new message.
 */
export const GetAgentTraceSummaryResponseSchema: GenMessage<GetAgentTraceSummaryResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 40);

/**
 * @generated from message gitpod.v1.GetAgentTraceTimeSeriesRequest
 */
export type GetAgentTraceTimeSeriesRequest = Message<"gitpod.v1.GetAgentTraceTimeSeriesRequest"> & {
  /**
   * Date range to query within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to scope results.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution: Resolution;

  /**
   * Optional user ID to scope results to a specific user.
   * Mutually exclusive with team_id.
   *
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * Optional team ID to scope results to a specific team.
   * Mutually exclusive with user_id.
   *
   * @generated from field: string team_id = 5;
   */
  teamId: string;
};

/**
 * Describes the message gitpod.v1.GetAgentTraceTimeSeriesRequest.
 * Use `create(GetAgentTraceTimeSeriesRequestSchema)` to create a new message.
 */
export const GetAgentTraceTimeSeriesRequestSchema: GenMessage<GetAgentTraceTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 41);

/**
 * @generated from message gitpod.v1.GetAgentTraceTimeSeriesResponse
 */
export type GetAgentTraceTimeSeriesResponse = Message<"gitpod.v1.GetAgentTraceTimeSeriesResponse"> & {
  /**
   * Time series of agent trace stats, bucketed by the requested resolution.
   *
   * @generated from field: repeated gitpod.v1.AgentTraceTimeBucket time_series = 1;
   */
  timeSeries: AgentTraceTimeBucket[];
};

/**
 * Describes the message gitpod.v1.GetAgentTraceTimeSeriesResponse.
 * Use `create(GetAgentTraceTimeSeriesResponseSchema)` to create a new message.
 */
export const GetAgentTraceTimeSeriesResponseSchema: GenMessage<GetAgentTraceTimeSeriesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 42);

/**
 * @generated from message gitpod.v1.GetPrSummaryRequest
 */
export type GetPrSummaryRequest = Message<"gitpod.v1.GetPrSummaryRequest"> & {
  /**
   * Date range to query within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to scope results.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Optional user ID to scope results to a specific user.
   * Mutually exclusive with team_id.
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * Optional team ID to scope results to a specific team.
   * Mutually exclusive with user_id.
   *
   * @generated from field: string team_id = 4;
   */
  teamId: string;
};

/**
 * Describes the message gitpod.v1.GetPrSummaryRequest.
 * Use `create(GetPrSummaryRequestSchema)` to create a new message.
 */
export const GetPrSummaryRequestSchema: GenMessage<GetPrSummaryRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 43);

/**
 * @generated from message gitpod.v1.GetPrSummaryResponse
 */
export type GetPrSummaryResponse = Message<"gitpod.v1.GetPrSummaryResponse"> & {
  /**
   * Summary totals and trends for the requested date range.
   *
   * @generated from field: gitpod.v1.PrSummary summary = 1;
   */
  summary?: PrSummary;

  /**
   * Sparkline data for card rendering.
   *
   * @generated from field: repeated gitpod.v1.TimeSeriesPoint sparkline = 2;
   */
  sparkline: TimeSeriesPoint[];
};

/**
 * Describes the message gitpod.v1.GetPrSummaryResponse.
 * Use `create(GetPrSummaryResponseSchema)` to create a new message.
 */
export const GetPrSummaryResponseSchema: GenMessage<GetPrSummaryResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 44);

/**
 * @generated from message gitpod.v1.GetPrTimeSeriesRequest
 */
export type GetPrTimeSeriesRequest = Message<"gitpod.v1.GetPrTimeSeriesRequest"> & {
  /**
   * Date range to query within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional project ID to scope results.
   *
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Time resolution for the series data.
   *
   * @generated from field: gitpod.v1.Resolution resolution = 3;
   */
  resolution: Resolution;

  /**
   * Optional user ID to scope results to a specific user.
   * Mutually exclusive with team_id.
   *
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * Optional team ID to scope results to a specific team.
   * Mutually exclusive with user_id.
   *
   * @generated from field: string team_id = 5;
   */
  teamId: string;
};

/**
 * Describes the message gitpod.v1.GetPrTimeSeriesRequest.
 * Use `create(GetPrTimeSeriesRequestSchema)` to create a new message.
 */
export const GetPrTimeSeriesRequestSchema: GenMessage<GetPrTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 45);

/**
 * @generated from message gitpod.v1.GetPrTimeSeriesResponse
 */
export type GetPrTimeSeriesResponse = Message<"gitpod.v1.GetPrTimeSeriesResponse"> & {
  /**
   * Time series of PR speed metrics, bucketed by the requested resolution.
   *
   * @generated from field: repeated gitpod.v1.PrTimeBucket time_series = 1;
   */
  timeSeries: PrTimeBucket[];
};

/**
 * Describes the message gitpod.v1.GetPrTimeSeriesResponse.
 * Use `create(GetPrTimeSeriesResponseSchema)` to create a new message.
 */
export const GetPrTimeSeriesResponseSchema: GenMessage<GetPrTimeSeriesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_usage, 46);

/**
 * Resolution specifies the time granularity for time series data.
 *
 * @generated from enum gitpod.v1.Resolution
 */
export enum Resolution {
  /**
   * @generated from enum value: RESOLUTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESOLUTION_HOURLY = 1;
   */
  HOURLY = 1,

  /**
   * @generated from enum value: RESOLUTION_DAILY = 2;
   */
  DAILY = 2,

  /**
   * @generated from enum value: RESOLUTION_WEEKLY = 3;
   */
  WEEKLY = 3,

  /**
   * @generated from enum value: RESOLUTION_MONTHLY = 4;
   */
  MONTHLY = 4,
}

/**
 * Describes the enum gitpod.v1.Resolution.
 */
export const ResolutionSchema: GenEnum<Resolution> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_usage, 0);

/**
 * CoAuthorTool identifies the AI tool that co-authored a commit.
 * UNSPECIFIED (0) is the proto default and must not appear in reported data.
 * Use HUMAN for commits with no AI co-author.
 *
 * @generated from enum gitpod.v1.CoAuthorTool
 */
export enum CoAuthorTool {
  /**
   * @generated from enum value: CO_AUTHOR_TOOL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Commit has no Co-authored-by trailer at all (solo commit).
   *
   * @generated from enum value: CO_AUTHOR_TOOL_NO_COAUTHOR = 1;
   */
  NO_COAUTHOR = 1,

  /**
   * Commit has a Co-authored-by trailer, but the co-author is human.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_HUMAN_COAUTHOR = 2;
   */
  HUMAN_COAUTHOR = 2,

  /**
   * Ona agent.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_ONA = 3;
   */
  ONA = 3,

  /**
   * GitHub Copilot.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_GITHUB_COPILOT = 4;
   */
  GITHUB_COPILOT = 4,

  /**
   * Cursor.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_CURSOR = 5;
   */
  CURSOR = 5,

  /**
   * An AI tool not in the known list.
   *
   * @generated from enum value: CO_AUTHOR_TOOL_OTHER = 6;
   */
  OTHER = 6,

  /**
   * Claude (Anthropic).
   *
   * @generated from enum value: CO_AUTHOR_TOOL_CLAUDE = 7;
   */
  CLAUDE = 7,
}

/**
 * Describes the enum gitpod.v1.CoAuthorTool.
 */
export const CoAuthorToolSchema: GenEnum<CoAuthorTool> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_usage, 1);

/**
 * UsageService provides usage information about environments, users, and projects.
 *
 * @generated from service gitpod.v1.UsageService
 */
export const UsageService: GenService<{
  /**
   * Gets the count of active users.
   *
   * Returns the count of unique users who were active within the specified date range.
   *
   * @generated from rpc gitpod.v1.UsageService.GetActiveUsersCount
   */
  getActiveUsersCount: {
    methodKind: "unary";
    input: typeof GetActiveUsersCountRequestSchema;
    output: typeof GetActiveUsersCountResponseSchema;
  },
  /**
   * Gets the top active users based on total runtime.
   *
   * Returns a list of users sorted by their total environment runtime within the specified date range.
   * Each result includes the user ID, name (if available), and their total environment runtime in seconds.
   *
   * @generated from rpc gitpod.v1.UsageService.GetTopActiveUsers
   */
  getTopActiveUsers: {
    methodKind: "unary";
    input: typeof GetTopActiveUsersRequestSchema;
    output: typeof GetTopActiveUsersResponseSchema;
  },
  /**
   * Gets active users time series in the specified date range, aggregated by the specified resolution.
   *
   * Returns a time series of active user counts within the specified date range, aggregated by the specified resolution.
   * Each data point includes the timestamp and the count of unique users who were active at that time.
   *
   * @generated from rpc gitpod.v1.UsageService.GetActiveUsersTimeSeries
   */
  getActiveUsersTimeSeries: {
    methodKind: "unary";
    input: typeof GetActiveUsersTimeSeriesRequestSchema;
    output: typeof GetActiveUsersTimeSeriesResponseSchema;
  },
  /**
   * Lists completed environment runtime records within a specified date range.
   *
   * Returns a list of environment runtime records that were completed within the specified date range. Records of currently running environments are not included.
   *
   * Use this method to:
   * - View environment runtime records
   * - Filter by project
   * - Create custom usage reports
   *
   * ### Example
   *
   * ```yaml
   * filter:
   *   projectId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   dateRange:
   *     startTime: "2024-01-01T00:00:00Z"
   *     endTime: "2024-01-02T00:00:00Z"
   * pagination:
   *   pageSize: 100
   * ```
   *
   * @generated from rpc gitpod.v1.UsageService.ListEnvironmentUsageRecords
   */
  listEnvironmentUsageRecords: {
    methodKind: "unary";
    input: typeof ListEnvironmentUsageRecordsRequestSchema;
    output: typeof ListEnvironmentUsageRecordsResponseSchema;
  },
  /**
   * Gets the count of active environments in the specified date range.
   *
   * @generated from rpc gitpod.v1.UsageService.GetActiveEnvironmentsCount
   */
  getActiveEnvironmentsCount: {
    methodKind: "unary";
    input: typeof GetActiveEnvironmentsCountRequestSchema;
    output: typeof GetActiveEnvironmentsCountResponseSchema;
  },
  /**
   * Gets the active environments time series in the specified date range, aggregated by the specified resolution.
   *
   * @generated from rpc gitpod.v1.UsageService.GetActiveEnvironmentsTimeSeries
   */
  getActiveEnvironmentsTimeSeries: {
    methodKind: "unary";
    input: typeof GetActiveEnvironmentsTimeSeriesRequestSchema;
    output: typeof GetActiveEnvironmentsTimeSeriesResponseSchema;
  },
  /**
   * Gets the total runtime of all environments in the specified date range.
   *
   * @generated from rpc gitpod.v1.UsageService.GetEnvironmentRuntime
   */
  getEnvironmentRuntime: {
    methodKind: "unary";
    input: typeof GetEnvironmentRuntimeRequestSchema;
    output: typeof GetEnvironmentRuntimeResponseSchema;
  },
  /**
   * Gets the total runtime time series in the specified date range, aggregated by the specified resolution.
   *
   * @generated from rpc gitpod.v1.UsageService.GetEnvironmentRuntimeTimeSeries
   */
  getEnvironmentRuntimeTimeSeries: {
    methodKind: "unary";
    input: typeof GetEnvironmentRuntimeTimeSeriesRequestSchema;
    output: typeof GetEnvironmentRuntimeTimeSeriesResponseSchema;
  },
  /**
   * Gets the top projects by total environment runtime in the specified date range.
   *
   * @generated from rpc gitpod.v1.UsageService.GetTopProjects
   */
  getTopProjects: {
    methodKind: "unary";
    input: typeof GetTopProjectsRequestSchema;
    output: typeof GetTopProjectsResponseSchema;
  },
  /**
   * Gets the top environment classes by total runtime in the specified date range.
   *
   * @generated from rpc gitpod.v1.UsageService.GetTopEnvironmentClasses
   */
  getTopEnvironmentClasses: {
    methodKind: "unary";
    input: typeof GetTopEnvironmentClassesRequestSchema;
    output: typeof GetTopEnvironmentClassesResponseSchema;
  },
  /**
   * Gets a summary of adoption and usage metrics for the insight card.
   *
   * Returns all scalar values, trends, and a sparkline for the Adoption & Usage
   * insight category. Designed for the Project Home page card and similar summary
   * views. For full-resolution time series, use the individual time series RPCs.
   *
   * @generated from rpc gitpod.v1.UsageService.GetAdoptionUsageSummary
   */
  getAdoptionUsageSummary: {
    methodKind: "unary";
    input: typeof GetAdoptionUsageSummaryRequestSchema;
    output: typeof GetAdoptionUsageSummaryResponseSchema;
  },
  /**
   * Gets the environment sessions time series in the specified date range, aggregated by the specified resolution.
   *
   * Environment sessions count total environment starts (environment.started events),
   * as opposed to GetActiveEnvironmentsTimeSeries which counts distinct environment IDs.
   *
   * @generated from rpc gitpod.v1.UsageService.GetEnvironmentSessionsTimeSeries
   */
  getEnvironmentSessionsTimeSeries: {
    methodKind: "unary";
    input: typeof GetEnvironmentSessionsTimeSeriesRequestSchema;
    output: typeof GetEnvironmentSessionsTimeSeriesResponseSchema;
  },
  /**
   * Gets aggregated co-author summary for the organization or a specific project.
   *
   * @generated from rpc gitpod.v1.UsageService.GetCoAuthorSummary
   */
  getCoAuthorSummary: {
    methodKind: "unary";
    input: typeof GetCoAuthorSummaryRequestSchema;
    output: typeof GetCoAuthorSummaryResponseSchema;
  },
  /**
   * Gets co-author contribution data as a time series.
   *
   * @generated from rpc gitpod.v1.UsageService.GetCoAuthorTimeSeries
   */
  getCoAuthorTimeSeries: {
    methodKind: "unary";
    input: typeof GetCoAuthorTimeSeriesRequestSchema;
    output: typeof GetCoAuthorTimeSeriesResponseSchema;
  },
  /**
   * Gets aggregated agent trace summary for the organization or a specific project.
   *
   * @generated from rpc gitpod.v1.UsageService.GetAgentTraceSummary
   */
  getAgentTraceSummary: {
    methodKind: "unary";
    input: typeof GetAgentTraceSummaryRequestSchema;
    output: typeof GetAgentTraceSummaryResponseSchema;
  },
  /**
   * Gets agent trace data as a time series.
   *
   * @generated from rpc gitpod.v1.UsageService.GetAgentTraceTimeSeries
   */
  getAgentTraceTimeSeries: {
    methodKind: "unary";
    input: typeof GetAgentTraceTimeSeriesRequestSchema;
    output: typeof GetAgentTraceTimeSeriesResponseSchema;
  },
  /**
   * Gets aggregated PR speed summary for the organization or a specific project.
   *
   * @generated from rpc gitpod.v1.UsageService.GetPrSummary
   */
  getPrSummary: {
    methodKind: "unary";
    input: typeof GetPrSummaryRequestSchema;
    output: typeof GetPrSummaryResponseSchema;
  },
  /**
   * Gets PR speed metrics as a time series.
   *
   * @generated from rpc gitpod.v1.UsageService.GetPrTimeSeries
   */
  getPrTimeSeries: {
    methodKind: "unary";
    input: typeof GetPrTimeSeriesRequestSchema;
    output: typeof GetPrTimeSeriesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_usage, 0);

